










import Vue from "vue";
import Component from "vue-class-component";

import {
  DashboardService,
  PrevisaoFaturamento,
} from "@/services/dashboard.service";
import ChartBar from "@/shared/components/chart-bar.vue";
import { Prop, Watch } from "vue-property-decorator";

import { moeda } from "@/shared/filters";
import { ticks, title } from "@/shared/utils/chart";

@Component({
  components: { ChartBar },
})
export default class GraficoPrevisaoFaturamento extends Vue {
  //Atributos
  readonly options: Chart.ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    tooltips: {
      mode: "index",
      callbacks: {
        //Callback para montar o titulo do tooltip
        title: title(),
        //Configurar label do tooltip retornar o texto customizado
        //Com esta configuração deve retornar ex.: "Cartão: R$ 20,00"
        //Ao invés de: "Cartão: 20"
        label: (i, data) => {
          return (
            (data.datasets ?? [])[i.datasetIndex ?? 0].label +
            ": " +
            moeda(+(i.value ?? "0"))
          );
        },
      },
    },
    scales: {
      yAxes: [
        {
          stacked: true,
          ticks: {
            //Começar gráfico a partir do zero, sem valores negativos
            beginAtZero: true,
            //Função que retorna o valor a ser mostrado no eixo y
            //Inplementada para mascarar o valor numério para o formato moeda
            callback: moeda,
          },
        },
      ],
      xAxes: [
        {
          stacked: true,
          ticks: {
            callback: ticks(),
          },
        },
      ],
    },
  };
  loading = false;
  source: PrevisaoFaturamento[] | null = null;
  //Fim Atributos

  //Props
  @Prop() readonly value!: string;
  //Fim Props

  //Computed
  get labels() {
    return (this.source ?? []).map((x) => x.data);
  }
  get dataSets(): Chart.ChartDataSets[] {
    return [
      {
        label: "Cartão",
        backgroundColor: "#3e95cd",
        data: (this.source ?? []).map((x) => x.valorCartao),
      },
      {
        label: "Não definido",
        backgroundColor: "#cecece",
        data: (this.source ?? []).map((x) => x.valorPagseguro),
      },
      {
        label: "Previsto Cartão",
        backgroundColor: "#3e95cd88",
        data: (this.source ?? []).map((x) => x.previstoCartao),
      },
      {
        label: "Previsto não definido",
        backgroundColor: "#cecece88",
        data: (this.source ?? []).map((x) => x.previstoPagseguro),
      },
    ];
  }
  //Fim Computed

  mounted() {
    this.onValueChange(this.value);
  }
  @Watch("value")
  async onValueChange(val: string) {
    this.loading = true;
    if (val) {
      this.source = await DashboardService.previsaoFaturamento(val).finally(
        () => (this.loading = false)
      );
    }
  }
}
